import React from 'react';

import * as styles from './ImageLabel.styles';

export enum ImageLabelColor {
  Green = 'green',
  Grey = 'grey',
  Red = 'red',
}

export interface ImageLabelProps {
  color: ImageLabelColor;
  text: string;
}

export const ImageLabel = ({ color, text }: ImageLabelProps) => {
  switch (color) {
    case ImageLabelColor.Red:
      return <div css={[styles.root, styles.red]}>{text}</div>;
    case ImageLabelColor.Green:
      return <div css={[styles.root, styles.green]}>{text}</div>;
    case ImageLabelColor.Grey:
      return <div css={[styles.root, styles.grey]}>{text}</div>;
    default:
      return null;
  }
};
